<template>
    <div>
        <flat-pickr  id="pickr" ref="pickr" :disabled="isDisabled" :config="config" v-model="date"></flat-pickr>
    </div>
</template>

<script>
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { Russian } from 'flatpickr/dist/l10n/ru.js'

export default {
  components: {
    flatPickr
  },
  props: {
    isDisabled: false
  },
  data () {
    return {
      picker: null,
      date: this.$root.getMomentWithTZDelta(new Date() / 1000).toDate(),
      dateFormatOnChange: 'DD-M-YYYY HH:mm:ss',
      config: {
        enableTime: true,
        altFormat: 'd-m-Y H:i:S',
        altInput: true,
        minuteIncrement: 1,
        allowInput: true,
        dateFormat: 'd-m-Y H:i:S',
        time_24hr: true,
        monthSelectorType: 'static',
        locale: localStorage.getItem('locale') === 'ru' ? Russian : null,
        onChange: this.onChange,
        onClose: this.onClose,
        onReady: this.onReady
      }

    }
  },
  methods: {
    onReady (selectedDates, dateStr, instance) {
      this.picker = instance
      this.$emit('ready', this.picker)
    },
    setDate (date) {
      this.picker.setDate(date)
    },
    onClose (selectedDates, dateStr, instance) {
      if (dateStr === '') {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Empty date is not allowed'), 'Error')
        return
      }
      let date = moment(dateStr, this.dateFormatOnChange).unix()
      this.$emit('onDateChanged', date)
    },
    onChange (selectedDates, dateStr, instance) {
      if (dateStr === '') {
        return
      }
      let date = moment(dateStr, this.dateFormatOnChange).unix()
      this.$emit('onDateChanged', date)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/flatPicker.vue